export default "__VITE_ASSET__9d82d7da__"